export default __webpack_public_path__ + "static/media/09.5f3ff76a.jpg";